import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ContentProvider } from "@/context/ContentContext";
import { CurrencyProvider } from "@/context/CurrencyContext";

import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CookieBanner from "@/components/layout/CookieBanner";
import CartDrawer from "@/components/layout/CartDrawer";

import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Edits from "@/pages/Edits";
import ProductDetail from "@/pages/ProductDetail";
import Checkout from "@/pages/Checkout";
import OrderConfirmation from "@/pages/OrderConfirmation";
import SellWithUs from "@/pages/SellWithUs";
import HowItWorks from "@/pages/HowItWorks";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Account from "@/pages/Account";
import Admin from "@/pages/Admin";
import Legal from "@/pages/Legal";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ContentProvider>
                    <CurrencyProvider>
                    <CartProvider>
                    <ScrollToTop />
                    <Header />
                    <main>
                        <Routes>
                            <Route path="/" element={<Home />} />
                            <Route path="/shop" element={<Shop />} />
                            <Route path="/edits" element={<Edits />} />
                            <Route path="/product/:id" element={<ProductDetail />} />
                            <Route path="/checkout" element={<Checkout />} />
                            <Route path="/order/:id" element={<OrderConfirmation />} />
                            <Route path="/sell" element={<SellWithUs />} />
                            <Route path="/how-it-works" element={<HowItWorks />} />
                            <Route path="/about" element={<About />} />
                            <Route path="/contact" element={<Contact />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<Register />} />
                            <Route path="/account" element={<Account />} />
                            <Route path="/admin" element={<Admin />} />
                            <Route path="/legal/:slug" element={<Legal />} />
                        </Routes>
                    </main>
                    <Footer />
                    <CartDrawer />
                    <CookieBanner />
                    </CartProvider>
                    </CurrencyProvider>
                </ContentProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}
